import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { formValueSelector, reduxForm, initialize, destroy, change } from 'redux-form'
import validate from './validate'
import * as routeSelectors from 'services/routes/selectors'
import * as userSelectors from 'services/user/selectors'
import * as selectOptions from '../constants'
import { selectShouldSeeAds } from 'services/premium/selectors'
import { Row, Col } from 'react-flexbox-grid'
import Button from 'components/util/Button'
import styles from './_routeSearchForm.css'
import { FormattedMessage } from 'react-intl'
import CharField from 'components/forms/CharField/CharField'
import SelectField from 'components/forms/SelectField'
import CheckboxField from 'components/forms/CheckboxField'
import TopCities from './TopCities'
import { AD_SIZES } from 'services/ads/constants'
import Ad from 'components/util/ads/Ad'
import SearchCityStateField from 'components/forms/SearchCityStateField'

export const FORM_NAME = 'routeSearch'
const formSelector = formValueSelector(FORM_NAME)

const formOptions = {
  form: FORM_NAME,
  validate,
}

const mapStateToProps = (state) => ({
  distanceType: formSelector(state, 'distanceType'),
  formattedUserCoords: routeSelectors.selectFormattedUserCoords(state),
  unitPreference: userSelectors.selectUnitPreference(state),
  shouldSeeAds: selectShouldSeeAds(state),
})

const mapDispatchToActions = {
  initialize,
  destroy,
}

export class RouteSearchForm extends Component {
  static propTypes = {
    distanceType: PropTypes.string,
    formattedUserCoords: PropTypes.string,
    setLocation: PropTypes.func,
    handleSubmit: PropTypes.func,
    initialize: PropTypes.func,
    destroy: PropTypes.func,
    onSearchRoutes: PropTypes.func,
    dispatch: PropTypes.func,
    unitPreference: PropTypes.string,
    shouldSeeAds: PropTypes.bool,
  }

  state = {
    showTopCities: false,
  }

  componentDidMount () {
    const { dispatch, unitPreference } = this.props

    const formUnitDefault = unitPreference === 'imperial' ? 'mi' : 'km'

    dispatch(initialize(FORM_NAME, {
      distanceType: selectOptions.DISTANCE_TYPE_AT_LEAST,
      distanceMinimum: '3',
      distanceMaximum: '200',
      unit: formUnitDefault,
      radius: '50000',
    }))
  }

  componentDidUpdate (prevProps) {
    const { formattedUserCoords } = this.props

    if ((prevProps.formattedUserCoords === null) && (formattedUserCoords !== null)) {
      this.props.dispatch(change(FORM_NAME, 'location', formattedUserCoords))
      this.props.onSearchRoutes()
    }
  }

  componentWillUnmount () {
    this.props.destroy(FORM_NAME)
  }

  handleToggleTopCities = () => {
    this.setState({
      showTopCities: !this.state.showTopCities,
    })
  }

  handleTriggerSearch = () => {
    setTimeout(this.props.handleSubmit)
  }

  render () {
    const {
      handleSubmit,
      distanceType,
      shouldSeeAds,
    } = this.props

    const { showTopCities } = this.state

    const showMaxLength = distanceType === selectOptions.DISTANCE_TYPE_BETWEEN

    return (
      <Row>
        <Col xs={12} md={shouldSeeAds ? 8 : 12}>
          <div className={styles.formContainer}>
            <form onSubmit={handleSubmit}>
              <Row>
                <Col xs={12}>
                  <Row>
                    <Col xs={12} sm={6} md={5}>
                      <CharField
                        name='routeName'
                        placeholder='Route name or keyword'
                        labelComponent={(
                          <FormattedMessage
                            id='routesearch.name'
                            defaultMessage='Search Routes:' />
                        )}
                      />
                    </Col>
                    <Col xs={12} sm={6} md={5}>
                      <SearchCityStateField
                        name='location'
                        placeholder='City, state, zip, or landmark'
                        required={true}
                        labelComponent={(
                          <FormattedMessage
                            id='routesearch.location.name'
                            defaultMessage='Near:' />
                        )}
                        errorComponent={(
                          <FormattedMessage
                            id='routesearch.location.error'
                            defaultMessage='Route location is required' />
                        )}
                      />
                    </Col>
                    <Col xs={12} sm={2}>
                      <div className={styles.submitButtonDesktop}>
                        <Button
                          el='button'
                          type='primary'
                          size='medium'>
                          <FormattedMessage id='routesearch.submit' defaultMessage='Search' />
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={12} md={shouldSeeAds ? 6 : 3}>
                      <SelectField
                        onChange={this.handleTriggerSearch}
                        name='activityType'
                        placeholder='All Activities...'
                        options={selectOptions.ACTIVITY_TYPES} />
                    </Col>
                    <Col xs={12} md={shouldSeeAds ? 6 : 2}>
                      <SelectField
                        onChange={this.handleTriggerSearch}
                        name='distanceType'
                        placeholder='Distance Type'
                        options={selectOptions.DISTANCE_TYPES} />
                    </Col>
                    <Col xs={12} sm={showMaxLength ? 6 : 12} md={shouldSeeAds ? 2 : 1}>
                      <CharField
                        placeholder='Min'
                        type='number'
                        name='distanceMinimum' />
                    </Col>
                    {showMaxLength ?
                      <Col xs={12} sm={6} md={2}>
                        <div className={styles.maxContainer}>
                          <CharField
                            placeholder='Max'
                            type='number'
                            name='distanceMaximum' />
                        </div>
                      </Col> : null}
                    <Col xs={12} sm={6} md={2}>
                      <SelectField
                        onChange={this.handleTriggerSearch}
                        name='unit'
                        options={selectOptions.UNITS} />
                    </Col>
                    <Col xs={12} sm={6} md={shouldSeeAds ? 6 : 2}>
                      <SelectField
                        onChange={this.handleTriggerSearch}
                        name='radius'
                        placeholder='Search Radius'
                        options={selectOptions.SEARCH_RADIUS} />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4} xs={12}>
                      <CheckboxField
                        name='mobileOnly'
                        onChange={this.handleTriggerSearch}
                        labelComponent={(
                          <FormattedMessage
                            id='routesearch.mobileonly.label'
                            defaultMessage='Mobile Only' />
                        )}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col md={4} xs={12}>
                      <a className={styles.showTopCities} onClick={this.handleToggleTopCities}>
                        {!showTopCities ?
                          <FormattedMessage
                            id='routesearch.showtopcities'
                            defaultMessage='Show top cities' />
                        :
                          <FormattedMessage
                            id='routesearch.hidetopcities'
                            defaultMessage='Hide top cities' />
                        }
                      </a>
                    </Col>
                  </Row>
                </Col>
                <Col xs={12}>
                  <div className={styles.submitButtonMobile}>
                    <Button
                      el='button'
                      type='primary'
                      size='medium'>
                      <FormattedMessage id='routesearch.submit' defaultMessage='Search' />
                    </Button>
                  </div>
                </Col>
              </Row>
              {showTopCities ? <TopCities /> : null}
            </form>
          </div>
        </Col>
        <Col xs={12} md={4}>
          <Ad sizes={[AD_SIZES.RAIL_2]} />
        </Col>
      </Row>
    )
  }
}

export const Form = reduxForm(formOptions)(RouteSearchForm)
export default connect(mapStateToProps, mapDispatchToActions, null, { withRef: false })(Form)
